export type { AnchorMap, OrderedSequence } from './types';
export { buildThreePointAnchors } from './types';
export { registerSequence, getSequence } from './registry';
export {
  academicTermSequence,
  decrementTermYear,
  normalizeTermInput,
  type AcademicTermMember,
} from './instances/academic-term';

import { registerSequence } from './registry';
import { academicTermSequence } from './instances/academic-term';

registerSequence(academicTermSequence);
